const axiosSettings = { withCredentials: false, headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }

const { createStore } = Vuex;

async function fetchExpertserviceData(url) {
	const http = axios.create(axiosSettings);
	const response = await http.get(url);
	return response.data;
}


export default config =>
	createStore({
		state: {
			data: null,
			fallbackError: null,
			search: config.search,
			inputitem: '',
			resulttxt: config.resulttxt,
			isLoading: false
		},
		actions: {

			async getExpertserviceData({ state, commit }) {
				commit('setIsLoading', true);
				const datas = await fetchExpertserviceData(config.url).catch((err) => {
					console.error("Fetching navigation data has error: ", err);
					commit('logError', config.fallbackError);
					return null;
				});
				if (!datas) {
					return;
				}
				commit('setIsLoading', false);
				commit('setExpertserviceData', datas);

			}
		},
		getters: {
		},
		mutations: {
			setExpertserviceData(state, model) {
				state.data = model;
			},
			updateInputEntry (state, inputitem) {
				state.inputitem = inputitem;
			},
			setIsLoading(state, isLoading) {
				state.isLoading = isLoading;
			},
			logError(state, fallbackError) {
				state.isLoading = false;
				state.fallbackError = fallbackError;
			}
		}
	});
